export default __webpack_public_path__ + "static/media/p3.531db370.jpg";